import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { useTranslation } from "react-i18next"
import MultiSelect from "components/common/MultiSelect"
import MultiSelectWithSearch from "components/common/MultiSelectWithSearch"
import FilterChips from "ui/FilterChips"
import styles from "./index.module.css"

const EquipmentFilters = ({ selectedCategories, selectedPools, onCategoryChange, onPoolChange, categoryOptions = [], equipmentPoolOptions = [] }) => {
  const { t } = useTranslation()

  return (
    <Flex vertical gap={12}>
      <Flex gap={12}>
        <MultiSelectWithSearch
          value={selectedPools || []}
          onChange={onPoolChange}
          options={equipmentPoolOptions}
          placeholder={t("booking.equipment.equipment_pools_placeholder")}
          searchPlaceholder="Search equipment"
          style={{ minWidth: 250, maxWidth: 280 }}
          t={t}
        />

        <MultiSelect
          value={selectedCategories}
          onChange={onCategoryChange}
          options={categoryOptions}
          placeholder={t("booking.equipment.category_filter")}
          dropdownClassName={styles.categoryDropdown}
          t={t}
        />
      </Flex>

      <FilterChips selectedValues={selectedCategories} options={categoryOptions} onChange={onCategoryChange} />
    </Flex>
  )
}

EquipmentFilters.propTypes = {
  selectedCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedPools: PropTypes.arrayOf(PropTypes.string).isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  onPoolChange: PropTypes.func.isRequired,
  categoryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  equipmentPoolOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired
}

export default EquipmentFilters
